window.$ = window.jQuery = require('jquery');
require('jquery-mask-plugin');
require('imagesloaded');

// jQuery
jQuery(function()
{

  // Void click
  $("body").on("click", "[data-void]", function(e)
  {
    e.preventDefault();
  });

  var scroll_width = window.innerWidth - $(document).width();

  // Modal 
  $("body").on("click", "[data-modal-open]", function()
  {
    var _me = $(this);
    var _elem = _me.attr("data-modal-open");
    var _target = $("body").find(_elem);

    $(document).trigger('show.modal.bimber', {
      modal: _elem,
      trigger: _me,
    });

    if ( ! _target.is(":visible"))
    {
      _target.css('display', 'block');
      $("html").css('overflow-y', 'hidden').css('padding-right', scroll_width + 'px');
    }
  });

  // Modals
  $("body").on("click", "[data-modal-dismiss], .modal-backdrop", function()
  {
    $.each($("body").find(".modal"), function()
    {
      if ($(this).is(":visible"))
      {
        $(this).css('display', 'none');
        $("html").css('overflow-y', 'auto').css('padding-right', '0px');
      }
    });
  });

  // Modals ESC press
  $(document).keyup(function(e) 
  {
    if (e.key === "Escape") 
    {
      $.each($("body").find(".modal"), function()
      {
        if ($(this).is(":visible"))
        {
          $(this).css('display', 'none');
          $("html").css('overflow-y', 'auto').css('padding-right', '0px');
        }
      });
    }
  });

});